// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` :root {
            /* Primary Purple */
            --primary-color: #9E6CE7;
            --primary-hover: #8A5BC7;
            
            /* Secondary Green */
            --secondary-color: #8AD2A3;
            --secondary-hover: #7BC49A;
            
            /* Accent Pink/Coral */
            --accent-coral: #E7919E;
            --accent-light-coral: #FF8C8D;
            
            /* Neutral colors */
            --text-primary: #333333;
            --text-secondary: #666666;
            --bg-light: #f8f9fa;
            --bg-white: #FFFFFF;
            --border-color: #eeeeee;
            
            /* Background */
            --bg-dark: #ffffff;
            --card-bg: #ffffff;
            
            /* Gradients */
            --gradient-purple-pink: linear-gradient(135deg, #9E6CE7 0%, #E7919E 100%);
            --gradient-green-purple: linear-gradient(135deg, #8AD2A3 0%, #9E6CE7 100%);
            --gradient-light-coral: linear-gradient(135deg, #FF8C8D 0%, #E7919E 100%);
            
            /* Legacy support */
            --input-bg: #ffffff;
            --input-border: #eeeeee;
            --button-hover: #8A5BC7;
            --error-color: #E7919E;
        }
body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: var(--bg-light);
  background-image: 
    radial-gradient(circle at 25% 25%, rgba(158, 108, 231, 0.08) 0%, transparent 40%),
    radial-gradient(circle at 75% 75%, rgba(231, 145, 158, 0.08) 0%, transparent 40%);
  color: var(--text-primary);
}

.app-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--bg-light);
  background-image: 
    radial-gradient(circle at 25% 25%, rgba(158, 108, 231, 0.08) 0%, transparent 40%),
    radial-gradient(circle at 75% 75%, rgba(231, 145, 158, 0.08) 0%, transparent 40%);
}

.phone-container {
  width: 20rem;
  height: 40rem;
  background-color: var(--bg-white);
  border-radius: 16px;
  padding: 40px;
  box-shadow: 0 8px 32px rgba(158, 108, 231, 0.15);
  backdrop-filter: blur(10px);
  border: 1px solid var(--border-color);
  position: relative;
}


.phone-header h1 {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
}


.phone-content {
  padding: 1rem;
}

.call-screen {
  text-align: center;
}

.caller-name {
  font-size: 1.5rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  color: var(--primary-color);
}

.call-status {
  color: var(--text-secondary);
  margin-bottom: 1rem;
}

.call-duration {
  font-size: 1.25rem;
  margin-bottom: 2rem;
  color: var(--text-secondary);
}

.button-container {
  display: flex;
  justify-content: center;
  gap: 2rem;

}

.call-button {
  padding: 1rem;
  border-radius: 9999px;
  border: none;
  cursor: pointer;
  transition: all 0.3s ease;
  position: absolute;
  bottom: 5%;
}

.call-button:hover {
  transform: scale(1.05);
}

.call-button:active {
  transform: scale(0.95);
}

.mute-button {
  background-color: var(--bg-light);
  border: 1px solid var(--border-color);
  color: var(--text-primary);
}

.mute-button:hover {
  background-color: var(--secondary-color);
  border-color: var(--secondary-hover);
  color: white;
}

.mute-button.muted {
  background-color: var(--accent-coral);
  border-color: var(--accent-coral);
  color: white;
}

.end-call-button {
  background: var(--gradient-light-coral);
  color: #ffffff;
  padding: 1.5rem;
  border: none;
  border-radius: 50%;
  transition: all 0.3s ease;
}

.end-call-button:hover {
  background: var(--accent-coral);
  box-shadow: 
    0 0 10px rgba(231, 145, 158, 0.5),
    0 0 20px rgba(231, 145, 158, 0.3),
    0 0 30px rgba(231, 145, 158, 0.2);
  transform: scale(1.05);
}

.end-call-button:active {
  transform: scale(0.95);
  box-shadow: 
    0 0 3px rgba(231, 145, 158, 0.5),
    0 0 6px rgba(231, 145, 158, 0.3),
    0 0 12px rgba(231, 145, 158, 0.2);
}

.start-call-container {
  display: flex;
  justify-content: center;
  margin-top: 5rem;
}

.start-call-button {
  background: var(--gradient-purple-pink);
  color: #ffffff;
  padding: 1.5rem;
  border: none;
  transition: all 0.3s ease;
}

.start-call-button:hover {
  background: var(--gradient-green-purple);
  transform: scale(1.05);
}

.start-call-button::before,
.start-call-button::after {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 2px solid var(--primary-color);
  transform: translate(-50%, -50%);
  opacity: 0.5;
}

.start-call-button::before {
  animation: ringPulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

.start-call-button::after {
  animation: ringPulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  animation-delay: 0.5s;
}

@keyframes ringPulse {
  0% {
    width: 100%;
    height: 100%;
    opacity: 1;
  }
  100% {
    width: 200%;
    height: 200%;
    opacity: 0;
  }
}
@media (max-width: 640px) {
  .phone-container {
    width: 100%;
    height: 100vh;
    border-radius: 0;
  }
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(158, 108, 231, 0.7);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(158, 108, 231, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(158, 108, 231, 0);
  }
}

.call-screen {
  animation: pulse 2s infinite;
  margin-top:20%;
  color: var(--text-primary);
}

/* HTML RESET */

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
/* CODE */

body {
  background-color: var(--bg-light);
}

.card {
  position: absolute;
  overflow: hidden;
  width: 250px;
  height: 330px;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -75%);
  border-radius: 15px;
  background-color: var(--bg-white);
  border: 1px solid var(--border-color);
}

.header {
  position: relative;
  width: 100%;
  height: 70%;
  border-top-left-radius: 15px;
  border-top-right-radius: 15px;
  background-color: transparent;
}


@keyframes ring {
  0% {
    transform: rotate(0deg);
  }
  20% {
    transform: rotate(-20deg);
  }
  21% {
    transform: rotate(0deg);
  }
  40% {
    transform: rotate(-20deg);
  }
  41% {
    transform: rotate(0deg);
  }
  60% {
    transform: rotate(-20deg);
  }
  80% {
    transform: rotate(-10deg);
  }
  100% {
    transform: rotate(0deg);
  }
}

.cercle {
  position: absolute;
  width: 130px;
  height: 130px;
  transform: translate(-25px, -25px);
  border-radius: 50%;
  border: 25px solid var(--primary-color);
  background-color: transparent;
  animation: wave 1.4s infinite linear;
}

.two {
  animation-delay: 0.35s;
  opacity: 0;
}

.three {
  animation-delay: 0.7s;
  opacity: 0;
}

@keyframes wave {
  0% {
    width: 130px;
    height: 130px;
    transform: translate(-25px, -25px);
    opacity: 1;
    border-width: 15px;
  }
  100% {
    width: 320px;
    height: 320px;
    transform: translate(-120px, -120px);
    opacity: 0.1;
    border-width: 35px;
  }
}

.phoneNumber {
  width: 100%;
  font-family: 'Open Sans Condensed', sans-serif;
  font-size: 30px;
  text-align: center;
  transform: translateY(150px);
  color: var(--primary-color);
  font-weight: 600;
}

.calling {
  width: 100%;
  font-size: 16px;
  margin-top: 10px;
  text-align: center;
  font-weight: lighter;
  transform: translateY(150px);
  color: var(--text-secondary);
  animation: opacity 2.5s infinite linear;
}

@keyframes opacity {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.2;
  }
  100% {
    opacity: 1;
  }
}

.footer {
  position: relative;
  width: 100%;
  height: 30%;
  border-top: 1px solid var(--border-color);
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
  background-color: var(--bg-light);
}



/* Existing styles... */

/* Add these styles at the end of App.css */

.patient-form-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 2rem;
}

.patient-form {
  background-color: var(--bg-white);
  padding: 2rem;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(158, 108, 231, 0.1);
  width: 300px;
  border: 1px solid var(--border-color);
}

.patient-form h2 {
  margin-bottom: 1rem;
  text-align: center;
  color: var(--primary-color);
  font-weight: 600;
}

.patient-form input {
  width: 100%;
  padding: 0.75rem;
  margin-bottom: 1rem;
  border: 1px solid var(--border-color);
  border-radius: 5px;
  font-size: 1rem;
  color: var(--text-primary);
  background-color: var(--bg-white);
}

.patient-form input:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(158, 108, 231, 0.1);
}

.patient-form button {
  width: 100%;
  padding: 0.75rem;
  background: var(--gradient-green-purple);
  color: #ffffff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1rem;
  transition: all 0.3s ease;
  font-weight: 500;
}

.patient-form button:hover {
  background: var(--secondary-hover);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(138, 210, 163, 0.3);
}

.generated-link {
  margin-top: 1rem;
  display: flex;
  align-items: center;
}

.generated-link input {
  flex: 1 1;
  padding: 0.5rem;
  border: 1px solid var(--border-color);
  border-radius: 5px 0 0 5px;
  font-size: 0.9rem;
  color: var(--text-primary);
  background-color: var(--bg-white);
}

.generated-link button {
  padding: 0.5rem 1rem;
  background: var(--gradient-purple-pink);
  color: #ffffff;
  border: none;
  border-radius: 0 5px 5px 0;
  cursor: pointer;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  font-weight: 500;
}

.generated-link button:hover {
  background: var(--primary-hover);
  transform: translateY(-1px);
}

.consent-banner {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  background-color: var(--bg-white);
  padding: 20px;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(158, 108, 231, 0.15);
  z-index: 1000;
  max-width: 90%;
  width: 400px;
  text-align: center;
  backdrop-filter: blur(5px);
  border: 1px solid var(--border-color);
}

.consent-banner p {
  margin: 0 0 15px 0;
  color: var(--text-primary);
  font-size: 14px;
  line-height: 1.5;
}

.consent-button {
  background: var(--gradient-purple-pink);
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
  transition: all 0.2s;
  font-weight: 500;
}

.consent-button:hover {
  background: var(--gradient-green-purple);
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(158, 108, 231, 0.3);
}

.error-message {
  color: var(--accent-coral);
  font-size: 12px;
  margin-top: 10px;
  font-weight: 500;
}

/* Connecting Screen Styles */
.connecting-screen {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 60px 20px;
  min-height: 400px;
}

.loader-container {
  margin-bottom: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loader {
  width: 60px;
  height: 60px;
  border: 4px solid rgba(158, 108, 231, 0.2);
  border-top-color: var(--primary-color);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

.connection-status {
  font-size: 24px;
  font-weight: 600;
  color: var(--primary-color);
  margin-bottom: 12px;
  text-align: center;
  animation: pulse-text 2s ease-in-out infinite;
}

@keyframes pulse-text {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.6;
  }
}

.connection-message {
  font-size: 16px;
  color: var(--text-secondary);
  text-align: center;
  max-width: 300px;
}

/* Disabled button state */
.call-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"CAAC;YACW,mBAAmB;YACnB,wBAAwB;YACxB,wBAAwB;;YAExB,oBAAoB;YACpB,0BAA0B;YAC1B,0BAA0B;;YAE1B,sBAAsB;YACtB,uBAAuB;YACvB,6BAA6B;;YAE7B,mBAAmB;YACnB,uBAAuB;YACvB,yBAAyB;YACzB,mBAAmB;YACnB,mBAAmB;YACnB,uBAAuB;;YAEvB,eAAe;YACf,kBAAkB;YAClB,kBAAkB;;YAElB,cAAc;YACd,yEAAyE;YACzE,0EAA0E;YAC1E,yEAAyE;;YAEzE,mBAAmB;YACnB,mBAAmB;YACnB,uBAAuB;YACvB,uBAAuB;YACvB,sBAAsB;QAC1B;AACR;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;EAClC,iCAAiC;EACjC;;qFAEmF;EACnF,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC;;qFAEmF;AACrF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iCAAiC;EACjC,mBAAmB;EACnB,aAAa;EACb,gDAAgD;EAChD,2BAA2B;EAC3B,qCAAqC;EACrC,kBAAkB;AACpB;;;AAGA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;AACX;;;AAGA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;;AAEX;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;EACrC,0BAA0B;AAC5B;;AAEA;EACE,wCAAwC;EACxC,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,iCAAiC;EACjC,YAAY;AACd;;AAEA;EACE,uCAAuC;EACvC,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B;;;qCAGmC;EACnC,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;EACtB;;;qCAGmC;AACrC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,cAAc;EACd,eAAe;EACf,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,wCAAwC;EACxC,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,sCAAsC;EACtC,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;AACvB;;AAEA;EACE;IACE,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;EACA;IACE,WAAW;IACX,YAAY;IACZ,UAAU;EACZ;AACF;AACA;EACE;IACE,WAAW;IACX,aAAa;IACb,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,4CAA4C;EAC9C;EACA;IACE,6CAA6C;EAC/C;EACA;IACE,0CAA0C;EAC5C;AACF;;AAEA;EACE,4BAA4B;EAC5B,cAAc;EACd,0BAA0B;AAC5B;;AAEA,eAAe;;AAEf;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;AACxB;AACA,SAAS;;AAET;EACE,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,mBAAmB;EACnB,iCAAiC;EACjC,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,4BAA4B;EAC5B,6BAA6B;EAC7B,6BAA6B;AAC/B;;;AAGA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;AACF;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kCAAkC;EAClC,kBAAkB;EAClB,uCAAuC;EACvC,6BAA6B;EAG7B,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE;IACE,YAAY;IACZ,aAAa;IACb,kCAAkC;IAClC,UAAU;IACV,kBAAkB;EACpB;EACA;IACE,YAAY;IACZ,aAAa;IACb,oCAAoC;IACpC,YAAY;IACZ,kBAAkB;EACpB;AACF;;AAEA;EACE,WAAW;EACX,8CAA8C;EAC9C,eAAe;EACf,kBAAkB;EAClB,4BAA4B;EAC5B,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,4BAA4B;EAC5B,4BAA4B;EAG5B,uCAAuC;AACzC;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,yCAAyC;EACzC,+BAA+B;EAC/B,gCAAgC;EAChC,iCAAiC;AACnC;;;;AAIA,uBAAuB;;AAEvB,2CAA2C;;AAE3C;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,8CAA8C;EAC9C,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;EACrC,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,wCAAwC;EACxC,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,qCAAqC;EACrC,0BAA0B;EAC1B,iBAAiB;EACjB,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;EACE,oBAAoB;EACpB,uCAAuC;EACvC,cAAc;EACd,YAAY;EACZ,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,gDAAgD;EAChD,aAAa;EACb,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,0BAA0B;EAC1B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,sCAAsC;EACtC,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,6CAA6C;AAC/C;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE,eAAe;EACf,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB","sourcesContent":[" :root {\n            /* Primary Purple */\n            --primary-color: #9E6CE7;\n            --primary-hover: #8A5BC7;\n            \n            /* Secondary Green */\n            --secondary-color: #8AD2A3;\n            --secondary-hover: #7BC49A;\n            \n            /* Accent Pink/Coral */\n            --accent-coral: #E7919E;\n            --accent-light-coral: #FF8C8D;\n            \n            /* Neutral colors */\n            --text-primary: #333333;\n            --text-secondary: #666666;\n            --bg-light: #f8f9fa;\n            --bg-white: #FFFFFF;\n            --border-color: #eeeeee;\n            \n            /* Background */\n            --bg-dark: #ffffff;\n            --card-bg: #ffffff;\n            \n            /* Gradients */\n            --gradient-purple-pink: linear-gradient(135deg, #9E6CE7 0%, #E7919E 100%);\n            --gradient-green-purple: linear-gradient(135deg, #8AD2A3 0%, #9E6CE7 100%);\n            --gradient-light-coral: linear-gradient(135deg, #FF8C8D 0%, #E7919E 100%);\n            \n            /* Legacy support */\n            --input-bg: #ffffff;\n            --input-border: #eeeeee;\n            --button-hover: #8A5BC7;\n            --error-color: #E7919E;\n        }\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  background-color: var(--bg-light);\n  background-image: \n    radial-gradient(circle at 25% 25%, rgba(158, 108, 231, 0.08) 0%, transparent 40%),\n    radial-gradient(circle at 75% 75%, rgba(231, 145, 158, 0.08) 0%, transparent 40%);\n  color: var(--text-primary);\n}\n\n.app-container {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: var(--bg-light);\n  background-image: \n    radial-gradient(circle at 25% 25%, rgba(158, 108, 231, 0.08) 0%, transparent 40%),\n    radial-gradient(circle at 75% 75%, rgba(231, 145, 158, 0.08) 0%, transparent 40%);\n}\n\n.phone-container {\n  width: 20rem;\n  height: 40rem;\n  background-color: var(--bg-white);\n  border-radius: 16px;\n  padding: 40px;\n  box-shadow: 0 8px 32px rgba(158, 108, 231, 0.15);\n  backdrop-filter: blur(10px);\n  border: 1px solid var(--border-color);\n  position: relative;\n}\n\n\n.phone-header h1 {\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin: 0;\n}\n\n\n.phone-content {\n  padding: 1rem;\n}\n\n.call-screen {\n  text-align: center;\n}\n\n.caller-name {\n  font-size: 1.5rem;\n  font-weight: 700;\n  margin-bottom: 0.5rem;\n  color: var(--primary-color);\n}\n\n.call-status {\n  color: var(--text-secondary);\n  margin-bottom: 1rem;\n}\n\n.call-duration {\n  font-size: 1.25rem;\n  margin-bottom: 2rem;\n  color: var(--text-secondary);\n}\n\n.button-container {\n  display: flex;\n  justify-content: center;\n  gap: 2rem;\n\n}\n\n.call-button {\n  padding: 1rem;\n  border-radius: 9999px;\n  border: none;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  position: absolute;\n  bottom: 5%;\n}\n\n.call-button:hover {\n  transform: scale(1.05);\n}\n\n.call-button:active {\n  transform: scale(0.95);\n}\n\n.mute-button {\n  background-color: var(--bg-light);\n  border: 1px solid var(--border-color);\n  color: var(--text-primary);\n}\n\n.mute-button:hover {\n  background-color: var(--secondary-color);\n  border-color: var(--secondary-hover);\n  color: white;\n}\n\n.mute-button.muted {\n  background-color: var(--accent-coral);\n  border-color: var(--accent-coral);\n  color: white;\n}\n\n.end-call-button {\n  background: var(--gradient-light-coral);\n  color: #ffffff;\n  padding: 1.5rem;\n  border: none;\n  border-radius: 50%;\n  transition: all 0.3s ease;\n}\n\n.end-call-button:hover {\n  background: var(--accent-coral);\n  box-shadow: \n    0 0 10px rgba(231, 145, 158, 0.5),\n    0 0 20px rgba(231, 145, 158, 0.3),\n    0 0 30px rgba(231, 145, 158, 0.2);\n  transform: scale(1.05);\n}\n\n.end-call-button:active {\n  transform: scale(0.95);\n  box-shadow: \n    0 0 3px rgba(231, 145, 158, 0.5),\n    0 0 6px rgba(231, 145, 158, 0.3),\n    0 0 12px rgba(231, 145, 158, 0.2);\n}\n\n.start-call-container {\n  display: flex;\n  justify-content: center;\n  margin-top: 5rem;\n}\n\n.start-call-button {\n  background: var(--gradient-purple-pink);\n  color: #ffffff;\n  padding: 1.5rem;\n  border: none;\n  transition: all 0.3s ease;\n}\n\n.start-call-button:hover {\n  background: var(--gradient-green-purple);\n  transform: scale(1.05);\n}\n\n.start-call-button::before,\n.start-call-button::after {\n  content: '';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  border: 2px solid var(--primary-color);\n  transform: translate(-50%, -50%);\n  opacity: 0.5;\n}\n\n.start-call-button::before {\n  animation: ringPulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n}\n\n.start-call-button::after {\n  animation: ringPulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n  animation-delay: 0.5s;\n}\n\n@keyframes ringPulse {\n  0% {\n    width: 100%;\n    height: 100%;\n    opacity: 1;\n  }\n  100% {\n    width: 200%;\n    height: 200%;\n    opacity: 0;\n  }\n}\n@media (max-width: 640px) {\n  .phone-container {\n    width: 100%;\n    height: 100vh;\n    border-radius: 0;\n  }\n}\n\n@keyframes pulse {\n  0% {\n    box-shadow: 0 0 0 0 rgba(158, 108, 231, 0.7);\n  }\n  70% {\n    box-shadow: 0 0 0 10px rgba(158, 108, 231, 0);\n  }\n  100% {\n    box-shadow: 0 0 0 0 rgba(158, 108, 231, 0);\n  }\n}\n\n.call-screen {\n  animation: pulse 2s infinite;\n  margin-top:20%;\n  color: var(--text-primary);\n}\n\n/* HTML RESET */\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n}\n/* CODE */\n\nbody {\n  background-color: var(--bg-light);\n}\n\n.card {\n  position: absolute;\n  overflow: hidden;\n  width: 250px;\n  height: 330px;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -75%);\n  border-radius: 15px;\n  background-color: var(--bg-white);\n  border: 1px solid var(--border-color);\n}\n\n.header {\n  position: relative;\n  width: 100%;\n  height: 70%;\n  border-top-left-radius: 15px;\n  border-top-right-radius: 15px;\n  background-color: transparent;\n}\n\n\n@keyframes ring {\n  0% {\n    transform: rotate(0deg);\n  }\n  20% {\n    transform: rotate(-20deg);\n  }\n  21% {\n    transform: rotate(0deg);\n  }\n  40% {\n    transform: rotate(-20deg);\n  }\n  41% {\n    transform: rotate(0deg);\n  }\n  60% {\n    transform: rotate(-20deg);\n  }\n  80% {\n    transform: rotate(-10deg);\n  }\n  100% {\n    transform: rotate(0deg);\n  }\n}\n\n.cercle {\n  position: absolute;\n  width: 130px;\n  height: 130px;\n  transform: translate(-25px, -25px);\n  border-radius: 50%;\n  border: 25px solid var(--primary-color);\n  background-color: transparent;\n  -webkit-animation: wave 1.4s infinite linear;\n  -o-animation: wave 1.4s infinite linear;\n  animation: wave 1.4s infinite linear;\n}\n\n.two {\n  animation-delay: 0.35s;\n  opacity: 0;\n}\n\n.three {\n  animation-delay: 0.7s;\n  opacity: 0;\n}\n\n@keyframes wave {\n  0% {\n    width: 130px;\n    height: 130px;\n    transform: translate(-25px, -25px);\n    opacity: 1;\n    border-width: 15px;\n  }\n  100% {\n    width: 320px;\n    height: 320px;\n    transform: translate(-120px, -120px);\n    opacity: 0.1;\n    border-width: 35px;\n  }\n}\n\n.phoneNumber {\n  width: 100%;\n  font-family: 'Open Sans Condensed', sans-serif;\n  font-size: 30px;\n  text-align: center;\n  transform: translateY(150px);\n  color: var(--primary-color);\n  font-weight: 600;\n}\n\n.calling {\n  width: 100%;\n  font-size: 16px;\n  margin-top: 10px;\n  text-align: center;\n  font-weight: lighter;\n  transform: translateY(150px);\n  color: var(--text-secondary);\n  -webkit-animation: opacity 2.5s infinite linear;\n  -o-animation: opacity 2.5s infinite linear;\n  animation: opacity 2.5s infinite linear;\n}\n\n@keyframes opacity {\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.2;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n.footer {\n  position: relative;\n  width: 100%;\n  height: 30%;\n  border-top: 1px solid var(--border-color);\n  border-bottom-left-radius: 15px;\n  border-bottom-right-radius: 15px;\n  background-color: var(--bg-light);\n}\n\n\n\n/* Existing styles... */\n\n/* Add these styles at the end of App.css */\n\n.patient-form-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin-top: 2rem;\n}\n\n.patient-form {\n  background-color: var(--bg-white);\n  padding: 2rem;\n  border-radius: 10px;\n  box-shadow: 0 4px 6px rgba(158, 108, 231, 0.1);\n  width: 300px;\n  border: 1px solid var(--border-color);\n}\n\n.patient-form h2 {\n  margin-bottom: 1rem;\n  text-align: center;\n  color: var(--primary-color);\n  font-weight: 600;\n}\n\n.patient-form input {\n  width: 100%;\n  padding: 0.75rem;\n  margin-bottom: 1rem;\n  border: 1px solid var(--border-color);\n  border-radius: 5px;\n  font-size: 1rem;\n  color: var(--text-primary);\n  background-color: var(--bg-white);\n}\n\n.patient-form input:focus {\n  outline: none;\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 3px rgba(158, 108, 231, 0.1);\n}\n\n.patient-form button {\n  width: 100%;\n  padding: 0.75rem;\n  background: var(--gradient-green-purple);\n  color: #ffffff;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n  font-weight: 500;\n}\n\n.patient-form button:hover {\n  background: var(--secondary-hover);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(138, 210, 163, 0.3);\n}\n\n.generated-link {\n  margin-top: 1rem;\n  display: flex;\n  align-items: center;\n}\n\n.generated-link input {\n  flex: 1;\n  padding: 0.5rem;\n  border: 1px solid var(--border-color);\n  border-radius: 5px 0 0 5px;\n  font-size: 0.9rem;\n  color: var(--text-primary);\n  background-color: var(--bg-white);\n}\n\n.generated-link button {\n  padding: 0.5rem 1rem;\n  background: var(--gradient-purple-pink);\n  color: #ffffff;\n  border: none;\n  border-radius: 0 5px 5px 0;\n  cursor: pointer;\n  font-size: 0.9rem;\n  transition: all 0.3s ease;\n  font-weight: 500;\n}\n\n.generated-link button:hover {\n  background: var(--primary-hover);\n  transform: translateY(-1px);\n}\n\n.consent-banner {\n  position: fixed;\n  bottom: 20px;\n  left: 50%;\n  transform: translateX(-50%);\n  background-color: var(--bg-white);\n  padding: 20px;\n  border-radius: 10px;\n  box-shadow: 0 2px 10px rgba(158, 108, 231, 0.15);\n  z-index: 1000;\n  max-width: 90%;\n  width: 400px;\n  text-align: center;\n  backdrop-filter: blur(5px);\n  border: 1px solid var(--border-color);\n}\n\n.consent-banner p {\n  margin: 0 0 15px 0;\n  color: var(--text-primary);\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.consent-button {\n  background: var(--gradient-purple-pink);\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 14px;\n  transition: all 0.2s;\n  font-weight: 500;\n}\n\n.consent-button:hover {\n  background: var(--gradient-green-purple);\n  transform: translateY(-1px);\n  box-shadow: 0 4px 8px rgba(158, 108, 231, 0.3);\n}\n\n.error-message {\n  color: var(--accent-coral);\n  font-size: 12px;\n  margin-top: 10px;\n  font-weight: 500;\n}\n\n/* Connecting Screen Styles */\n.connecting-screen {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 20px;\n  min-height: 400px;\n}\n\n.loader-container {\n  margin-bottom: 30px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.loader {\n  width: 60px;\n  height: 60px;\n  border: 4px solid rgba(158, 108, 231, 0.2);\n  border-top-color: var(--primary-color);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.connection-status {\n  font-size: 24px;\n  font-weight: 600;\n  color: var(--primary-color);\n  margin-bottom: 12px;\n  text-align: center;\n  animation: pulse-text 2s ease-in-out infinite;\n}\n\n@keyframes pulse-text {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.6;\n  }\n}\n\n.connection-message {\n  font-size: 16px;\n  color: var(--text-secondary);\n  text-align: center;\n  max-width: 300px;\n}\n\n/* Disabled button state */\n.call-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
